import { makeStyles } from "tss-react/mui";
import { PaletteColor } from "@mui/material/styles";

export interface IParams {
    backgroundColor?: PaletteColor["main"];
    isCompactLayout?: boolean;
}

export const useStyle = makeStyles<IParams>()((theme, props) => ({
    container: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: 30,
        borderRadius: `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0 0`,
        backgroundColor: props.backgroundColor ?? theme.palette.secondary.main,
        paddingInline: theme.spacing(3),
        marginLeft: props.isCompactLayout ? undefined : theme.spacing(4),
    },
    text: {
        fontWeight: theme.typography.fontWeightRegular,
        lineHeight: 1,
        whiteSpace: "nowrap",
    },
}));
